import { CreateProperty } from './CreateProperty';

/**
 * CreatePropertyPage - Page wrapper for the Create Property form
 * 
 * All necessary providers (Customer, Services, Business, Jobs, Properties)
 * are provided at the route level in App.tsx
 */
export default function CreatePropertyPage() {
  return <CreateProperty />;
};
